import { GridColumnMenuProps } from '@progress/kendo-react-grid';
import CustomDropdownFilter, { Option } from 'src/components/custom-cells/CustomDropdownFilter';

const ActiveFilterCellOptions: Option[] = [
  {
    text: 'Show Active',
    operator: true,
  },
  {
    text: 'Show Inactive',
    operator: false,
  },
];
const FixedFilterCellOption: Option[] = [
  {
    text: 'Show Fixed',
    operator: true,
  },
  {
    text: 'Show Variable',
    operator: false,
  },
];

export const ActiveFilterCell = (props: GridColumnMenuProps) => (
  <CustomDropdownFilter {...props} option={ActiveFilterCellOptions} />
);
export const FixedFilterCell = (props: GridColumnMenuProps) => (
  <CustomDropdownFilter {...props} option={FixedFilterCellOption} />
);
